// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P7NR","questions":"styles_questions__8_8YT","footer":"styles_footer__25qQ-"};